module.exports = __webpack_public_path__ + "static/media/policeCar_indigo.d8d38870.svg";